import type { ReturnMode } from "@babackapp/return-widget-components/types";

/**
 * The return-mode step only earns its screen when the customer has something
 * to decide or read there: a second mode, a pickup date, or a merchant message.
 * Only a lone carrier mode is skipped: a store (and its picker) or a lone
 * retractation mode (BBS-385) keeps the step.
 */
export const canSkipReturnMode = ({
  modes,
  isPickup,
  hasCallout,
}: {
  modes: ReturnMode[];
  isPickup: boolean;
  hasCallout: boolean;
}): boolean =>
  modes.length === 1 && modes[0] === "carrier" && !isPickup && !hasCallout;
